import api from './api';

export const getAllSeries = async (params = {}) => {
  const response = await api.get('/booking-series', { params });
  return response.data;
};

export const getSeries = async (id) => {
  const response = await api.get(`/booking-series/${id}`);
  return response.data;
};

export const previewSeries = async (seriesData) => {
  const response = await api.post('/booking-series/preview', seriesData);
  return response.data;
};

export const createSeries = async (seriesData) => {
  const response = await api.post('/booking-series', seriesData);
  return response.data;
};

export const updateSeries = async (id, seriesData) => {
  const response = await api.put(`/booking-series/${id}`, seriesData);
  return response.data;
};

export const deleteSeries = async (id, fromDate = null, cancelReason = null) => {
  const params = {};
  if (fromDate) params.from_date = fromDate;
  if (cancelReason) params.cancel_reason = cancelReason;
  const response = await api.delete(`/booking-series/${id}`, { params });
  return response.data;
};

export const extendSeries = async (id, newEndDate, excludedDates = []) => {
  const response = await api.post(`/booking-series/${id}/extend`, {
    new_end_date: newEndDate,
    excluded_dates: excludedDates
  });
  return response.data;
};

export const previewExtendSeries = async (id, newEndDate) => {
  const response = await api.post(`/booking-series/${id}/extend/preview`, {
    new_end_date: newEndDate
  });
  return response.data;
};

export const previewModifySeries = async (id, data) => {
  const response = await api.post(`/booking-series/${id}/modify-from/preview`, data);
  return response.data;
};

export const modifySeries = async (id, data) => {
  const response = await api.post(`/booking-series/${id}/modify-from`, data);
  return response.data;
};
